import React, { useState, useEffect } from 'react';
import './BuggyPreloader.css';

function BuggyPreloader({ onComplete }) {
    const [phase, setPhase] = useState('buggy'); // buggy → fixing → stable
    const [progress, setProgress] = useState(0);
    const [logs, setLogs] = useState([]);
    const [hasTypo, setHasTypo] = useState(true);

    useEffect(() => {
        // Phase 1: BUGGY (0-1600ms) - slowed down
        // Instant log appearance - no typing
        setTimeout(() => {
            setLogs(['[WARN] module checksum mismatch']);
        }, 200);

        setTimeout(() => {
            setLogs(prev => [...prev, '[ERROR] cache desync detected']);
        }, 600);

        // Progress bar starts
        setTimeout(() => setProgress(20), 800);
        setTimeout(() => setProgress(45), 1000);

        // Progress bar GLITCH - jumps backward
        setTimeout(() => setProgress(30), 1200);

        // Continue forward
        setTimeout(() => setProgress(55), 1400);

        // Typo appears
        setTimeout(() => {
            setLogs(prev => [...prev, '> initializng system...']);
        }, 1500);

        // Phase 2: FIXING (1600-2800ms) - slowed down
        setTimeout(() => {
            setPhase('fixing');

            // Typo auto-corrects instantly
            setHasTypo(false);
            setLogs(prev => {
                const newLogs = [...prev];
                newLogs[newLogs.length - 1] = '> initializing system...';
                return newLogs;
            });

            // Rapid recovery logs
            setLogs(prev => [...prev, '> applying hotfix...']);
        }, 1600);

        setTimeout(() => {
            setLogs(prev => [...prev, '> rebuilding modules...']);
            setProgress(75);
        }, 2000);

        setTimeout(() => {
            setLogs(prev => [...prev, '> error resolved ✓']);
            setProgress(100);
        }, 2400);

        // Phase 3: STABLE (2800ms)
        setTimeout(() => {
            setPhase('stable');
        }, 2800);

        // Smooth transition to terminal
        setTimeout(() => {
            onComplete();
        }, 3200);

    }, [onComplete]);

    return (
        <div className={`buggy-preloader phase-${phase}`}>
            <div className="preloader-window">
                <div className="preloader-header">
                    <div className="preloader-dots">
                        <span className="dot red"></span>
                        <span className="dot yellow"></span>
                        <span className="dot green"></span>
                    </div>
                    <span className="preloader-title">system.init</span>
                </div>

                <div className="preloader-content">
                    {logs.map((log, index) => (
                        <div
                            key={index}
                            className={`log-line ${log.includes('[WARN]') ? 'warn' :
                                    log.includes('[ERROR]') ? 'error' :
                                        log.includes('✓') ? 'success' : ''
                                }`}
                        >
                            {log}
                        </div>
                    ))}

                    {progress > 0 && (
                        <div className="progress-container">
                            <div className="progress-bar">
                                <div
                                    className="progress-fill"
                                    style={{ width: `${progress}%` }}
                                ></div>
                            </div>
                            <span className="progress-text">{progress}%</span>
                        </div>
                    )}

                    <div className={`cursor ${phase === 'buggy' ? 'flicker-fast' : ''}`}>_</div>
                </div>
            </div>
        </div>
    );
}

export default BuggyPreloader;
